<div  *ngIf='!hasNoColumns'style="pointer-events: auto !important; cursor: pointer;" (click)="noRowsOverlayClicked($event)" class=""
    fxLayoutAlign="center center">
    No Result Found.
</div>
<div *ngIf='hasNoColumns'>
<span>No Columns Selected</span>
</div>
